import React from 'react';

/**
 * Header
 * Component for top of site
 * 
 * 
 * @returns Header with title and subtitle
 */
function Header(){

    return (
        
        <div id="header">
            <h1> Tech Tips </h1>
            <p> Deployment instructions and more for coding and development </p>
        </div>
    );
}

export default Header;